import axios from "axios";
const config = {
	env: "local",
	// apiUrl: "http://localhost:5600/platform/v1",
	apiUrl: "https://sitepro-api.onap.uk/platform/v1",
	// apiUrl: "https://7cgqsbkf-5050.inc1.devtunnels.ms/admin",

};

const BASE_URL = config.apiUrl;

const client = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("platform_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const url: string = err.config?.url ?? "";
      if (url.includes("auth/me") || url.includes("auth/login")) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
    return Promise.reject(err.response?.data || err);
  }
);

export default client;
